export const listCross = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // 左上右下方向の革紐
  ctx.beginPath()
  ctx.moveTo(283 + x, 526 + y) // 左上
  ctx.quadraticCurveTo(291 + x, 561 + y, 321 + x, 572 + y) //
  ctx.quadraticCurveTo(335 + x, 568 + y, 335 + x, 568 + y) // 右下
  ctx.quadraticCurveTo(325 + x, 561 + y, 325 + x, 561 + y) // 右上
  ctx.quadraticCurveTo(299 + x, 553 + y, 287 + x, 524 + y) // 右上
  ctx.quadraticCurveTo(281 + x, 520 + y, 283 + x, 526 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 側面
  ctx.beginPath()
  ctx.moveTo(284 + x, 524 + y) // 上
  ctx.quadraticCurveTo(304 + x, 568 + y, 332 + x, 565 + y)
  ctx.stroke()
  ctx.closePath()

  // 右上左下方向の革紐
  ctx.beginPath()
  ctx.moveTo(291 + x, 555 + y) // 左上
  ctx.quadraticCurveTo(295 + x, 563 + y, 309 + x, 569 + y) // 左下
  ctx.quadraticCurveTo(293 + x, 547 + y, 310 + x, 525 + y) // 右下
  ctx.quadraticCurveTo(317 + x, 510 + y, 305 + x, 513 + y) // 右上
  ctx.quadraticCurveTo(287 + x, 527 + y, 291 + x, 555 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 側面
  ctx.beginPath()
  ctx.moveTo(312 + x, 517 + y) // 上
  ctx.quadraticCurveTo(285 + x, 548 + y, 309 + x, 569 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}

export const listStraightLittle = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // 左上右下方向の革紐
  ctx.beginPath()
  ctx.moveTo(285 + x, 520 + y) // 左上
  ctx.quadraticCurveTo(283 + x, 525 + y, 288 + x, 525 + y) // 左下
  ctx.quadraticCurveTo(292 + x, 523 + y, 313 + x, 517 + y) // 右下
  ctx.quadraticCurveTo(314 + x, 510 + y, 308 + x, 508 + y) // 右上
  ctx.quadraticCurveTo(281 + x, 517 + y, 285 + x, 520 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
